import { ManagementPeriodPaymentStatus } from "@leavy/lv-homesharing-srv/lib/hl/domain/HlManagementPeriodPayment";
import { IsEnum, IsOptional } from "@leavy/validator";

export class HlUserPaymentFiltersModel {
    @IsOptional()
    @IsEnum(ManagementPeriodPaymentStatus)
    status?: ManagementPeriodPaymentStatus;
}
